import { setTerms } from './helpers';

export const setSpecialtyTypes = setTerms('specialty_types');
